export default {
  // Regular expression used to validate emails
  EMAIL_REGEX:
    /^[_a-z0-9-]+(.[_a-z0-9-]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,3})$/,
  LOGIN_REGEX: /^[_.@A-Za-z0-9-]*$/,
};
